/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StatusEnum = "assigned" | "draft" | "not_valid" | "pending" | "published" | "report_uploaded" | "verified" | "%future added value";
export type UploadStatusEnum = "cancelled" | "completed" | "failed" | "initiated" | "not_started" | "%future added value";
export type FinalizeUploadInput = {|
  clientMutationId?: ?string,
  filename?: ?string,
  jobRequestId: number,
|};
export type FinalizeUploadMutationVariables = {|
  input: FinalizeUploadInput
|};
export type FinalizeUploadMutationResponse = {|
  +finalizeUpload: ?{|
    +success: boolean,
    +message: ?string,
    +jobRequest: ?{|
      +dbId: number,
      +id: string,
      +status: ?StatusEnum,
      +uploadStatus: ?UploadStatusEnum,
    |},
  |}
|};
export type FinalizeUploadMutation = {|
  variables: FinalizeUploadMutationVariables,
  response: FinalizeUploadMutationResponse,
|};
*/


/*
mutation FinalizeUploadMutation(
  $input: FinalizeUploadInput!
) {
  finalizeUpload(input: $input) {
    success
    message
    jobRequest {
      dbId
      id
      status
      uploadStatus
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FinalizeUploadPayload",
    "kind": "LinkedField",
    "name": "finalizeUpload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobRequest",
        "kind": "LinkedField",
        "name": "jobRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dbId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uploadStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FinalizeUploadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FinalizeUploadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dbff4246c57894ba895aba0be56bd5f4",
    "id": null,
    "metadata": {},
    "name": "FinalizeUploadMutation",
    "operationKind": "mutation",
    "text": "mutation FinalizeUploadMutation(\n  $input: FinalizeUploadInput!\n) {\n  finalizeUpload(input: $input) {\n    success\n    message\n    jobRequest {\n      dbId\n      id\n      status\n      uploadStatus\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3f5d53075ef930d94ae9539f62f7059d';

module.exports = node;
